import { FC } from "react";

const DarkModeSelectorLoader: FC = () => (
  <div className="animate-pulse">
    <div className="h-fit min-h-[3rem] min-w-[3rem] rounded-full bg-beige opacity-75 dark:bg-slate-800" />
  </div>
);

export default DarkModeSelectorLoader;
